import { Route, Redirect } from 'react-router-dom';

// Import hooks
import { useAuth } from 'components/utilities';

// Import routes
import { AuthPaths } from 'components/routes/auth/routes';

type Props = {
	path: string;
	component: any;
};

const ProtectedDashboard = ({ path, component }: Props) => {
	const { isAuth } = useAuth();

	if (!isAuth) return <Redirect to={AuthPaths.Login} />;

	return <Route path={path} component={component} />;
};

export default ProtectedDashboard;
